<template>
  <div v-if="isCompany">
    <div v-if="canEditCompany">
      <a href="#" @click.prevent="handleEditCompany">
        {{ company.name }}
      </a>
    </div>
    <div v-else>
      {{ company.name }}
    </div>
  </div>
</template>

<script>
import Permissions from '@/utilities/permissions'

export default {
  props: ['data'],
  computed: {
    isCompany() {
      return !!(this.data && this.data.name && this.data.id)
    },
    company() {
      if (!this.isCompany) {
        return {}
      }
      return this.data
    },
    canEditCompany() {
      return this.$can('edit', Permissions.COMPANIES)
    }
  },
  methods: {
    handleEditCompany() {
      this.$eventHub.$emit('show-modal-2', 'Company', {id: this.company.id} , '1000px')
    },
  }
}
</script>
